import React, { useEffect, useState } from 'react';
import './FormPreview.css';

const questions = [
  {
    question: "Question 1: What does 'Tawheed' mean?",
    options: ["Oneness of Allah", "Belief in Angels", "Five Pillars", "Prayer"]
  },
  {
    question: "Question 2: Fasting in Ramadan is...",
    options: ["Optional", "Only for scholars", "A pillar of Islam", "Only at night"]
  },
  {
    question: "Question 3: What is the first word revealed in the Qur'an?",
    input: true,
    placeholder: "Type your answer..."
  },
  {
    question: "Question 4: Write one benefit of daily Salah.",
    textarea: true,
    placeholder: "Enter your answer here"
  }
];

const FormPreview = () => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const cycle = setInterval(() => {
      setIndex((prev) => (prev + 1) % questions.length);
    }, 4000);
    return () => clearInterval(cycle);
  }, []);

  const current = questions[index];

  return (
    <div className="form-preview-wrapper">
      <h3 className="form-title">ISLAMIC BASICS QUIZ</h3>
      <div className="form-question-card">
        <p className="form-question-text">{current.question}</p>
        {current.options && (
          <div className="form-options">
            {current.options.map((opt, i) => (
              <label key={i} className="form-option">
                <input type="radio" disabled />
                {opt}
              </label>
            ))}
          </div>
        )}
        {current.input && (
          <input
            type="text"
            className="form-input"
            placeholder={current.placeholder}
            disabled
          />
        )}
        {current.textarea && (
          <textarea
            className="form-textarea"
            placeholder={current.placeholder}
            disabled
          />
        )}
      </div>
    </div>
  );
};

export default FormPreview;
